/* Alltagsheld:in – Linienzeichnungen zum Ausmalen.
   Erzeugt SVG-Markup für die Seite (Ausmalen im Browser) und für die Druck-PDFs.
   Jede ausmalbare Fläche hat class="f" und eine eigene id. */
(function (g) {
  'use strict';
  var INK = '#16141a';
  var n = 0;
  var heldin = false; // Alltagsheldin: Etikett ohne Schoko-Abzeichen
  function id() { n += 1; return 'ahp' + n; }
  function r(v) { return Math.round(v * 10) / 10; }
  function F(tag, attrs) {
    // ausmalbare Fläche
    var s = '<' + tag + ' class="f" id="' + id() + '" fill="#fff"';
    for (var k in attrs) s += ' ' + k + '="' + attrs[k] + '"';
    return s + '/>';
  }
  function L(tag, attrs) {
    // reine Linie, nicht ausmalbar
    var s = '<' + tag + ' fill="none"';
    for (var k in attrs) s += ' ' + k + '="' + attrs[k] + '"';
    return s + '/>';
  }
  function grp(tr, inner) { return '<g transform="' + tr + '">' + inner + '</g>'; }

  function cloud(x, y, s) {
    var d = 'M' + x + ' ' + y +
      ' a' + r(22 * s) + ' ' + r(22 * s) + ' 0 0 1 ' + r(26 * s) + ' ' + r(-30 * s) +
      ' a' + r(32 * s) + ' ' + r(32 * s) + ' 0 0 1 ' + r(58 * s) + ' ' + r(-14 * s) +
      ' a' + r(26 * s) + ' ' + r(26 * s) + ' 0 0 1 ' + r(44 * s) + ' ' + r(20 * s) +
      ' a' + r(20 * s) + ' ' + r(20 * s) + ' 0 0 1 ' + r(8 * s) + ' ' + r(24 * s) + ' Z';
    return F('path', { d: d, stroke: INK, 'stroke-width': 4, 'stroke-linejoin': 'round' });
  }

  function windowEl(x, y, w, h) {
    return F('rect', { x: x, y: y, width: w, height: h, rx: 3, stroke: INK, 'stroke-width': 3 }) +
      L('path', { d: 'M' + r(x + w / 2) + ' ' + y + 'V' + (y + h) + 'M' + x + ' ' + r(y + h * 0.45) + 'H' + (x + w), stroke: INK, 'stroke-width': 2.5 });
  }

  function house(x, y, w, h, opt) {
    opt = opt || {};
    var s = F('rect', { x: x, y: y, width: w, height: h, stroke: INK, 'stroke-width': 4 });
    s += F('rect', { x: x - 6, y: y - 14, width: w + 12, height: 18, stroke: INK, 'stroke-width': 4 });
    var cols = opt.cols || 2, rows = opt.rows || 3;
    var ww = w / (cols * 1.9), wh = ww * 1.35;
    var gapX = (w - cols * ww) / (cols + 1);
    var usableH = h - 90;
    var gapY = (usableH - rows * wh) / (rows + 1);
    for (var i = 0; i < rows; i++) {
      for (var j = 0; j < cols; j++) {
        s += windowEl(r(x + gapX + j * (ww + gapX)), r(y + 20 + gapY + i * (wh + gapY)), r(ww), r(wh));
      }
    }
    // Tür mit Bogen
    var dw = Math.min(46, w * 0.28), dx = x + (opt.doorLeft ? w * 0.18 : (w - dw) / 2), dy = y + h - 74;
    s += F('path', { d: 'M' + r(dx) + ' ' + (y + h) + 'V' + r(dy + dw / 2) + 'a' + r(dw / 2) + ' ' + r(dw / 2) + ' 0 0 1 ' + r(dw) + ' 0V' + (y + h) + 'Z', stroke: INK, 'stroke-width': 3.5 });
    if (opt.wreath) {
      s += F('circle', { cx: r(dx + dw / 2), cy: r(dy + dw / 2 + 4), r: 11, stroke: INK, 'stroke-width': 3 });
      s += F('circle', { cx: r(dx + dw / 2), cy: r(dy + dw / 2 + 4), r: 5, stroke: INK, 'stroke-width': 2.5 });
    }
    if (opt.snow) {
      // Schneehaube auf dem Gesims
      var d = 'M' + (x - 8) + ' ' + (y - 14);
      var steps = Math.max(3, Math.round((w + 16) / 34));
      var sw = (w + 16) / steps;
      for (var k = 0; k < steps; k++) d += ' q' + r(sw / 2) + ' ' + (k % 2 ? -16 : -22) + ' ' + r(sw) + ' 0';
      d += ' v6 H' + (x - 8) + 'Z';
      s += F('path', { d: d, stroke: INK, 'stroke-width': 3.5, 'stroke-linejoin': 'round' });
    }
    if (opt.garland) {
      // Lichterkette quer über die Fassade
      var gy = y + 18 + (opt.garlandY || 0);
      var seg = 4, segw = w / seg, gd = 'M' + x + ' ' + gy;
      for (var q = 0; q < seg; q++) gd += ' q' + r(segw / 2) + ' 22 ' + r(segw) + ' 0';
      s += L('path', { d: gd, stroke: INK, 'stroke-width': 3 });
      for (var b = 0; b < seg; b++) {
        s += F('circle', { cx: r(x + segw * (b + 0.5)), cy: r(gy + 13), r: 6, stroke: INK, 'stroke-width': 2.5 });
      }
    }
    return s;
  }

  function bean(cx, cy, rx, ry, rot, opt) {
    opt = opt || {};
    var s = F('ellipse', { cx: 0, cy: 0, rx: rx, ry: ry, stroke: INK, 'stroke-width': opt.sw || 4 });
    s += L('path', {
      d: 'M' + r(-rx * 0.06) + ' ' + r(-ry * 0.86) + ' C' + r(rx * 0.42) + ' ' + r(-ry * 0.3) + ' ' + r(-rx * 0.42) + ' ' + r(ry * 0.3) + ' ' + r(rx * 0.06) + ' ' + r(ry * 0.86),
      stroke: INK, 'stroke-width': opt.sw ? opt.sw - 0.5 : 3.5, 'stroke-linecap': 'round'
    });
    return grp('translate(' + cx + ' ' + cy + ') rotate(' + (rot || 0) + ')', s + (opt.extra || ''));
  }

  function sunglasses(rx, ry) {
    var y = -ry * 0.28, w = rx * 0.62, h = ry * 0.24;
    return F('rect', { x: r(-rx * 0.86), y: r(y), width: r(w), height: r(h), rx: r(h / 2.2), stroke: INK, 'stroke-width': 3 }) +
      F('rect', { x: r(rx * 0.22), y: r(y), width: r(w), height: r(h), rx: r(h / 2.2), stroke: INK, 'stroke-width': 3 }) +
      L('path', { d: 'M' + r(-rx * 0.24) + ' ' + r(y + h * 0.4) + 'H' + r(rx * 0.22), stroke: INK, 'stroke-width': 3 });
  }

  function brimHat(rx, ry) {
    return F('ellipse', { cx: 0, cy: r(-ry * 0.82), rx: r(rx * 1.15), ry: r(ry * 0.12), stroke: INK, 'stroke-width': 3 }) +
      F('path', { d: 'M' + r(-rx * 0.62) + ' ' + r(-ry * 0.84) + ' Q' + r(-rx * 0.6) + ' ' + r(-ry * 1.32) + ' 0 ' + r(-ry * 1.32) + ' Q' + r(rx * 0.6) + ' ' + r(-ry * 1.32) + ' ' + r(rx * 0.62) + ' ' + r(-ry * 0.84) + 'Z', stroke: INK, 'stroke-width': 3 }) +
      F('path', { d: 'M' + r(-rx * 0.6) + ' ' + r(-ry * 0.92) + ' H' + r(rx * 0.6) + ' V' + r(-ry * 1.02) + ' H' + r(-rx * 0.6) + 'Z', stroke: INK, 'stroke-width': 2.5 });
  }

  function beanie(rx, ry) {
    return F('path', { d: 'M' + r(-rx * 0.98) + ' ' + r(-ry * 0.5) + ' Q' + r(-rx * 1.0) + ' ' + r(-ry * 1.42) + ' 0 ' + r(-ry * 1.42) + ' Q' + r(rx * 1.0) + ' ' + r(-ry * 1.42) + ' ' + r(rx * 0.98) + ' ' + r(-ry * 0.5) + 'Z', stroke: INK, 'stroke-width': 3 }) +
      F('rect', { x: r(-rx * 1.04), y: r(-ry * 0.66), width: r(rx * 2.08), height: r(ry * 0.26), rx: 6, stroke: INK, 'stroke-width': 3 }) +
      F('circle', { cx: 0, cy: r(-ry * 1.5), r: r(rx * 0.3), stroke: INK, 'stroke-width': 3 });
  }

  function scarf(rx, ry) {
    return F('path', { d: 'M' + r(-rx * 0.98) + ' ' + r(ry * 0.12) + ' Q0 ' + r(ry * 0.36) + ' ' + r(rx * 0.98) + ' ' + r(ry * 0.12) + ' L' + r(rx * 0.96) + ' ' + r(ry * 0.34) + ' Q0 ' + r(ry * 0.58) + ' ' + r(-rx * 0.96) + ' ' + r(ry * 0.34) + 'Z', stroke: INK, 'stroke-width': 3 }) +
      F('path', { d: 'M' + r(rx * 0.3) + ' ' + r(ry * 0.4) + ' l' + r(rx * 0.1) + ' ' + r(ry * 0.6) + ' l' + r(rx * 0.32) + ' ' + r(-ry * 0.04) + ' l' + r(-rx * 0.1) + ' ' + r(-ry * 0.62) + 'Z', stroke: INK, 'stroke-width': 3 });
  }

  function suitcase(x, y) {
    return F('rect', { x: x, y: y, width: 44, height: 34, rx: 5, stroke: INK, 'stroke-width': 3.5 }) +
      L('path', { d: 'M' + (x + 14) + ' ' + y + 'v-9h16v9', stroke: INK, 'stroke-width': 3.5, 'stroke-linejoin': 'round' });
  }

  function mug(x, y, s, rot) {
    var splash = F('path', { d: 'M-26 -22 C-24 -50 -2 -60 16 -50 C30 -42 34 -28 52 -36 C48 -16 30 -12 20 -22 Z', stroke: INK, 'stroke-width': 3.5, 'stroke-linejoin': 'round' });
    var drop = F('ellipse', { cx: 58, cy: -50, rx: 5, ry: 7, transform: 'rotate(20 58 -50)', stroke: INK, 'stroke-width': 3 });
    var body = F('rect', { x: -32, y: -24, width: 64, height: 54, rx: 11, stroke: INK, 'stroke-width': 4 });
    var handle = F('path', { d: 'M32 -10 a16 16 0 1 1 0 30 v-9 a7 7 0 1 0 0 -12 z', stroke: INK, 'stroke-width': 3.5, 'stroke-linejoin': 'round' });
    return grp('translate(' + x + ' ' + y + ') rotate(' + rot + ') scale(' + s + ')', splash + drop + body + handle);
  }

  function snowman(x, y) {
    var t = F('circle', { cx: 0, cy: 0, r: 44, stroke: INK, 'stroke-width': 4 }) +
      F('circle', { cx: 0, cy: -66, r: 32, stroke: INK, 'stroke-width': 4 }) +
      F('circle', { cx: 0, cy: -116, r: 24, stroke: INK, 'stroke-width': 4 }) +
      F('rect', { x: -20, y: -158, width: 40, height: 26, rx: 3, stroke: INK, 'stroke-width': 3.5 }) +
      F('rect', { x: -28, y: -136, width: 56, height: 8, rx: 3, stroke: INK, 'stroke-width': 3 }) +
      F('path', { d: 'M2 -116 L30 -110 L2 -106 Z', stroke: INK, 'stroke-width': 3, 'stroke-linejoin': 'round' }) +
      F('circle', { cx: -8, cy: -124, r: 3.5, stroke: INK, 'stroke-width': 2 }) + F('circle', { cx: 9, cy: -124, r: 3.5, stroke: INK, 'stroke-width': 2 }) +
      F('circle', { cx: 0, cy: -72, r: 5, stroke: INK, 'stroke-width': 2.5 }) + F('circle', { cx: 0, cy: -54, r: 5, stroke: INK, 'stroke-width': 2.5 }) +
      L('path', { d: 'M-30 -74 L-66 -96 M-52 -86 L-60 -104 M30 -74 L66 -92 M54 -85 L66 -76', stroke: INK, 'stroke-width': 4, 'stroke-linecap': 'round' });
    return grp('translate(' + x + ' ' + y + ')', t);
  }

  function hero(xmas) {
    // Fliegende Heldenbohne mit Cape, Maske und Schoko-Abzeichen
    var cape = F('path', {
      d: 'M40 -70 C150 -90 250 -40 330 -20 C360 -12 392 -14 412 -26 C398 6 370 20 336 22 C352 40 346 62 320 70 C300 52 270 52 240 66 C180 92 120 100 60 80 Z',
      stroke: INK, 'stroke-width': 4.5, 'stroke-linejoin': 'round'
    });
    var fold = L('path', { d: 'M120 -40 C180 -20 230 10 300 22 M110 30 C170 40 220 44 280 40', stroke: INK, 'stroke-width': 3, 'stroke-linecap': 'round' });
    var body = F('ellipse', { cx: 0, cy: 0, rx: 92, ry: 118, stroke: INK, 'stroke-width': 5 });
    var crease = L('path', { d: 'M-6 -102 C40 -36 -40 36 6 104', stroke: INK, 'stroke-width': 4.5, 'stroke-linecap': 'round' });
    var mask = F('path', {
      d: 'M-96 -62 C-70 -86 40 -92 92 -70 C100 -52 96 -30 84 -18 C60 -8 40 -22 20 -26 C0 -30 -20 -10 -44 -10 C-70 -10 -96 -30 -96 -62 Z',
      stroke: INK, 'stroke-width': 4.5, 'stroke-linejoin': 'round'
    });
    var eye1 = F('ellipse', { cx: -52, cy: -48, rx: 22, ry: 13, transform: 'rotate(-8 -52 -48)', stroke: INK, 'stroke-width': 3.5 });
    var eye2 = F('ellipse', { cx: 40, cy: -54, rx: 22, ry: 13, transform: 'rotate(6 40 -54)', stroke: INK, 'stroke-width': 3.5 });
    var badge = heldin ? '' : (F('rect', { x: -26, y: 20, width: 52, height: 52, rx: 6, transform: 'rotate(-12 0 46)', stroke: INK, 'stroke-width': 4 }) +
      F('rect', { x: -15, y: 31, width: 30, height: 30, rx: 3, transform: 'rotate(-12 0 46)', stroke: INK, 'stroke-width': 3 }));
    var hat = '';
    if (xmas) {
      hat = F('path', { d: 'M-88 -88 C-70 -170 40 -200 120 -150 C150 -132 170 -110 176 -86 C150 -110 120 -118 96 -112 C60 -132 -20 -130 -88 -88 Z', stroke: INK, 'stroke-width': 4.5, 'stroke-linejoin': 'round' }) +
        F('path', { d: 'M-102 -96 C-60 -130 60 -134 112 -108 C118 -96 116 -84 108 -76 C60 -100 -50 -98 -98 -70 C-108 -76 -108 -88 -102 -96 Z', stroke: INK, 'stroke-width': 4, 'stroke-linejoin': 'round' }) +
        F('circle', { cx: 182, cy: -80, r: 22, stroke: INK, 'stroke-width': 4 });
    }
    var inner = cape + fold + grp('rotate(-18)', body + crease + mask + eye1 + eye2 + badge + hat);
    return inner;
  }

  function fir(x, y, s) {
    // Tannenbaum: drei Etagen, Stern, Kugeln
    var t = '';
    t += F('rect', { x: -12, y: 0, width: 24, height: 30, stroke: INK, 'stroke-width': 3.5 });
    t += F('path', { d: 'M-80 4 L0 -70 L80 4 Q40 14 0 6 Q-40 14 -80 4 Z', stroke: INK, 'stroke-width': 4, 'stroke-linejoin': 'round' });
    t += F('path', { d: 'M-64 -46 L0 -118 L64 -46 Q32 -36 0 -42 Q-32 -36 -64 -46 Z', stroke: INK, 'stroke-width': 4, 'stroke-linejoin': 'round' });
    t += F('path', { d: 'M-46 -92 L0 -158 L46 -92 Q22 -84 0 -88 Q-22 -84 -46 -92 Z', stroke: INK, 'stroke-width': 4, 'stroke-linejoin': 'round' });
    t += F('path', { d: 'M0 -190 L8 -170 L30 -170 L12 -158 L19 -137 L0 -150 L-19 -137 L-12 -158 L-30 -170 L-8 -170 Z', stroke: INK, 'stroke-width': 3.5, 'stroke-linejoin': 'round' });
    var balls = [[-40, -14], [30, -8], [-20, -60], [26, -64], [-6, -108], [52, -18]];
    balls.forEach(function (b) { t += F('circle', { cx: b[0], cy: b[1], r: 9, stroke: INK, 'stroke-width': 3 }); });
    return grp('translate(' + x + ' ' + y + ') scale(' + s + ')', t);
  }

  function roundTree(x, y, s) {
    var t = F('rect', { x: -12, y: -10, width: 24, height: 60, stroke: INK, 'stroke-width': 3.5 });
    t += F('path', { d: 'M-60 -10 a40 40 0 0 1 10 -70 a46 46 0 0 1 84 -14 a40 40 0 0 1 30 70 a30 30 0 0 1 -40 22 a40 40 0 0 1 -60 4 a30 30 0 0 1 -24 -12 Z', stroke: INK, 'stroke-width': 4, 'stroke-linejoin': 'round' });
    return grp('translate(' + x + ' ' + y + ') scale(' + s + ')', t);
  }

  function snowflake(x, y, s) {
    var d = '';
    for (var i = 0; i < 6; i++) {
      var a = i * Math.PI / 3, c = Math.cos(a), si = Math.sin(a);
      d += 'M' + x + ' ' + y + 'l' + r(c * 12 * s) + ' ' + r(si * 12 * s);
      d += 'M' + r(x + c * 7 * s) + ' ' + r(y + si * 7 * s) + 'l' + r(Math.cos(a + 0.6) * 5 * s) + ' ' + r(Math.sin(a + 0.6) * 5 * s);
      d += 'M' + r(x + c * 7 * s) + ' ' + r(y + si * 7 * s) + 'l' + r(Math.cos(a - 0.6) * 5 * s) + ' ' + r(Math.sin(a - 0.6) * 5 * s);
    }
    return L('path', { d: d, stroke: INK, 'stroke-width': 2.5, 'stroke-linecap': 'round' });
  }

  function scene(xmas) {
    var s = '';
    s += F('rect', { x: 0, y: 0, width: 800, height: 700, stroke: 'none' });
    s += cloud(40, 120, 1.1) + cloud(520, 90, 1.25) + cloud(300, 240, 0.8) + cloud(640, 300, 0.7);
    // Häuser hinten in der Mitte
    s += F('path', { d: 'M318 700 V560 H400 V540 H470 V560 H520 V700 Z', stroke: INK, 'stroke-width': 4 });
    s += F('path', { d: 'M344 700 v-46 a16 16 0 0 1 32 0 v46 Z', stroke: INK, 'stroke-width': 3 }) + F('path', { d: 'M398 700 v-46 a16 16 0 0 1 32 0 v46 Z', stroke: INK, 'stroke-width': 3 }) + F('path', { d: 'M452 700 v-46 a16 16 0 0 1 32 0 v46 Z', stroke: INK, 'stroke-width': 3 });
    // Häuser links und rechts
    s += house(150, 380, 180, 320, { cols: 2, rows: 3, snow: xmas, garland: xmas, garlandY: 96 });
    s += house(-10, 300, 175, 400, { cols: 2, rows: 4, doorLeft: true, snow: xmas, garland: xmas, wreath: xmas, garlandY: 0 });
    s += house(540, 410, 150, 290, { cols: 2, rows: 3, snow: xmas, garland: xmas, garlandY: 80 });
    s += house(670, 330, 140, 370, { cols: 2, rows: 4, snow: xmas, garland: xmas, wreath: xmas });
    // Baum in der Mitte
    s += xmas ? fir(500, 670, 0.62) : roundTree(470, 650, 0.85);
    // Straße bzw. Schnee
    if (xmas) {
      s += F('path', { d: 'M0 700 Q100 680 200 698 Q300 712 400 694 Q520 676 620 700 Q720 716 800 696 V1000 H0 Z', stroke: INK, 'stroke-width': 4, 'stroke-linejoin': 'round' });
      s += L('path', { d: 'M60 820 q60 -20 120 0 M480 900 q70 -24 140 0 M300 960 q40 -14 80 0', stroke: INK, 'stroke-width': 3, 'stroke-linecap': 'round' });
    } else {
      s += F('rect', { x: 0, y: 700, width: 800, height: 300, stroke: INK, 'stroke-width': 4 });
      s += L('path', { d: 'M400 700 L330 1000 M400 700 L470 1000 M400 760 V800 M400 840 V900 M400 940 V1000', stroke: INK, 'stroke-width': 3, 'stroke-linecap': 'round' });
      s += L('path', { d: 'M0 760 L180 700 M800 770 L620 700', stroke: INK, 'stroke-width': 3 });
    }
    // Speedlines
    // Bohnen auf der Straße
    s += suitcase(40, 852);
    s += bean(140, 860, 52, 68, 4, { extra: xmas ? beanie(52, 68) + scarf(52, 68) : '' });
    s += bean(270, 858, 52, 64, -6, { extra: sunglasses(52, 64) });
    s += bean(560, 850, 46, 60, 6, { extra: xmas ? beanie(46, 60) : '' });
    s += bean(690, 862, 52, 68, -4, { extra: xmas ? beanie(52, 68) + scarf(52, 68) : brimHat(52, 68) });
    if (xmas) s += snowman(418, 950);
    // Tassen
    s += mug(150, 200, 1.15, -12) + mug(640, 190, 1.05, 12);
    // Held
    s += grp('translate(300 400) scale(1.12)', hero(xmas));
    s += L('path', { d: 'M560 330 H700 M600 372 H760 M540 452 H690', stroke: INK, 'stroke-width': 3, 'stroke-linecap': 'round' });
    if (xmas) {
      [[90, 60], [250, 40], [430, 70], [700, 50], [600, 160], [60, 260], [360, 160], [740, 220], [110, 640], [520, 520]].forEach(function (p, i) { s += snowflake(p[0], p[1], i % 3 ? 1 : 1.4); });
    }
    return s;
  }

  function template() {
    var s = '';
    s += F('rect', { x: 0, y: 0, width: 800, height: 1000, stroke: 'none' });
    // Sonnenstrahlen-Hintergrund wie auf Comic-Covern
    for (var i = 0; i < 16; i++) {
      var a1 = i * Math.PI / 8, a2 = a1 + Math.PI / 16;
      var cx = 400, cy = 470, R = 900;
      s += F('path', { d: 'M' + cx + ' ' + cy + 'L' + r(cx + Math.cos(a1) * R) + ' ' + r(cy + Math.sin(a1) * R) + 'L' + r(cx + Math.cos(a2) * R) + ' ' + r(cy + Math.sin(a2) * R) + 'Z', stroke: INK, 'stroke-width': 2 });
    }
    // Cape hinter der Bohne
    s += F('path', { d: 'M260 300 C180 420 160 600 120 760 C200 730 260 760 320 740 C380 760 420 750 480 760 C540 750 600 770 680 760 C640 600 620 420 540 300 Z', stroke: INK, 'stroke-width': 5, 'stroke-linejoin': 'round' });
    // Bohne
    s += bean(400, 480, 170, 230, 0, { sw: 6 });
    // Maske
    s += F('path', { d: 'M232 360 C300 320 500 320 568 360 C574 392 562 420 540 430 C500 440 470 412 430 410 C412 410 388 410 370 410 C330 412 300 440 260 430 C238 420 226 392 232 360 Z', stroke: INK, 'stroke-width': 5, 'stroke-linejoin': 'round' });
    s += F('ellipse', { cx: 320, cy: 380, rx: 36, ry: 20, stroke: INK, 'stroke-width': 4 });
    s += F('ellipse', { cx: 480, cy: 380, rx: 36, ry: 20, stroke: INK, 'stroke-width': 4 });
    // Abzeichen
    s += F('circle', { cx: 400, cy: 560, r: 58, stroke: INK, 'stroke-width': 5 });
    s += F('circle', { cx: 400, cy: 560, r: 40, stroke: INK, 'stroke-width': 3 });
    // Boden
    s += F('path', { d: 'M0 860 Q200 830 400 850 Q600 870 800 840 V1000 H0 Z', stroke: INK, 'stroke-width': 4 });
    return s;
  }

  function art(motif, opt) {
    n = 0;
    heldin = motif === 'heldin';
    opt = opt || {};
    var inner = motif === 'eigene' ? template() : scene(motif === 'weihnachten');
    var clip = '<clipPath id="ahclip"><rect x="0" y="0" width="800" height="1000" rx="0"/></clipPath>';
    var frame = '<rect x="2" y="2" width="796" height="996" fill="none" stroke="' + INK + '" stroke-width="6"/>';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 1000" role="img" aria-label="' + (opt.label || 'Ausmalbild') + '"><defs>' + clip + '</defs><g clip-path="url(#ahclip)">' + inner + '</g>' + frame + '</svg>';
    return svg;
  }

  // Druckseite A4: Titel oben, Bild, Fußzeile
  function page(motif) {
    var titles = {
      alltag: ['ALLTAGSHELD', 'Ausmalbild · Co-Roast Nr. 3'],
      heldin: ['ALLTAGSHELDIN', 'Ausmalbild · Co-Roast Nr. 3'],
      weihnachten: ['WEIHNACHTSHELD', 'Ausmalbild · Weihnachts-Special'],
      eigene: ['DEIN HELD, DEINE HELDIN', 'Mal deine eigene Kaffeebohnen-Figur']
    };
    var t = titles[motif];
    var a = art(motif).replace('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 1000"', '<svg x="60" y="170" width="680" height="850" viewBox="0 0 800 1000"');
    var lines = '';
    if (motif === 'eigene') {
      lines = '<text x="60" y="1060" font-family="Jost" font-weight="600" font-size="22" fill="' + INK + '">Name:</text><line x1="140" y1="1062" x2="740" y2="1062" stroke="' + INK + '" stroke-width="2"/>' +
        '<text x="60" y="1100" font-family="Jost" font-weight="600" font-size="22" fill="' + INK + '">Superkraft:</text><line x1="190" y1="1102" x2="740" y2="1102" stroke="' + INK + '" stroke-width="2"/>';
    } else {
      lines = '<text x="400" y="1068" text-anchor="middle" font-family="Jost" font-weight="500" font-size="20" fill="' + INK + '">Gemalt von: ______________________________</text>';
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" width="210mm" height="297mm" viewBox="0 0 800 1131">' +
      '<rect width="800" height="1131" fill="#fff"/>' +
      '<text x="400" y="104" text-anchor="middle" font-family="Bangers" font-size="' + (t[0].length > 16 ? 64 : 84) + '" letter-spacing="2" fill="#fff" stroke="' + INK + '" stroke-width="3">' + t[0] + '</text>' +
      '<text x="400" y="146" text-anchor="middle" font-family="Jost" font-weight="600" font-size="22" letter-spacing="3" fill="' + INK + '">' + t[1].toUpperCase() + '</text>' +
      a + lines +
      '<text x="400" y="1116" text-anchor="middle" font-family="Jost" font-size="15" fill="' + INK + '">19grams × roasted. · Bloody Good Coffee aus Berlin</text>' +
      '</svg>';
  }

  var api = { art: art, page: page };
  g.AHArt = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
